import { defaultFormState } from '@/presentation/components/models';
import { atom } from 'recoil';
export const studentFirstLoginAtom = atom({
    key: 'studentFirstLoginAtom',
    default: Object.assign(Object.assign({}, defaultFormState), { username: '', dateOfBirthday: '', gender: null, ethnicity: null, usernameError: '', dateOfBirthdayError: '', genderError: '', ethnicityError: '' })
});
